<template>
  <div>
    <header class="fixed"  v-if="!user">
      <nav class="navbar">
        <div class="container">
        <div class="navbar-header">
          <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
          <span class="sr-only">Menu</span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          </button>
          <div class="navbar-brand">
          <router-link to="/" class="brand">
            <img src="/images/andalepide.svg" alt="Andalepide"/>
          </router-link>
         </div>
        </div>
        <div class="collapse navbar-collapse" id="navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
          <router-link tag="li" active-class="active" to="/suscripcion"><a>SUSCRIPCIÓN</a></router-link>
          <router-link tag="li" active-class="active" to="/ondemand"><a>ON-DEMAND</a></router-link>
          <router-link tag="li" active-class="active" to="/partners"><a>PARTNERS</a></router-link>
          <router-link tag="li" to="/login" style="margin-left:10px;" active-class="active"><a class="btn-login">INGRESAR</a></router-link>
          </ul>
        </div>
        </div>
      </nav>
    </header>
    <template v-else>
      <div class="user-sesion">
      <header v-if="user.roles[0] === 'admincliente' || user.roles[0] === 'user'">
        <nav class="navbar" v-if="!user.needsToAnswerCampaign">
          <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <span class="sr-only">Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            </button>
            <div class="navbar-brand">
            <router-link to="/" class="brand">
              <img src="/images/andalepide.svg" alt="Andalepide"/>
            </router-link>
           </div>
          </div>
          <div class="head-cart">
            <template v-if="user.roles[0] === 'admincliente' || user.roles[0] === 'user'">
              <a style="cursor: pointer" @click="toggleCarrito" class="total visible-lg visible-md show-aside-cart">
                <span >{{totalCarrito}}</span>
                <i class="icon-kart"></i>
              </a>
              <a class="hidden-lg hidden-md" href="#" @click.prevent="irACheckOut">
                <span >{{totalCarrito}}</span>
                <i class="icon-kart"></i>
              </a>
            </template>
          </div>
          <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
            <router-link tag="li" active-class="active" to="/hacerpedido"><a>MENÚ</a></router-link>
            
            <!-- visible solo para el usuario, ocultar para el admin de grupo-->
            <router-link to="/mispedidos" tag="li" active-class="active"><a>MIS PEDIDOS</a></router-link>
            <!-- -->
            
            <!-- Visible solo para el administrador de grupo-->
            <li class="dropdown" v-if="user.roles[0] === 'admincliente'">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">PANEL ADMINISTRACIÓN <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/adminpedidos"><a>Pedidos</a></router-link>
              <router-link tag="li" active-class="active" to="/usuarios"><a>Usuarios</a></router-link>
              <router-link tag="li" active-class="active" to="/historialempresa"><a>Historial Empresa</a></router-link>
              <router-link tag="li" active-class="active" to="/usuarios/liquidaciones"><a>Liquidaciones</a></router-link>
              </ul>
            </li>
            <!-- -->
            
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{user.displayName}} <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/perfil"><a>Perfil</a></router-link>
              <router-link tag="li" active-class="active" to="/logout"><a>Salir</a></router-link>
              </ul>
            </li>
            </ul>
          </div>
          </div>
        </nav>
        <nav v-else>
          <div class="container">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <span class="sr-only">Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            </button>
            <div class="navbar-brand">
            <router-link to="/" class="brand">
              <img src="/images/andalepide.svg" alt="Andalepide"/>
            </router-link>
           </div>
          </div>
          <div class="head-cart">
          </div>
          <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="nav navbar-nav navbar-right">            
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{user.displayName}} <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/logout"><a>Salir</a></router-link>
              </ul>
            </li>
            </ul>
          </div>
          </div>
        </nav>
      </header>
      <header class="static"  v-if="user.roles[0] === 'restaurante'">
        <nav class="navbar">
          <div class="container-fluid">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <span class="sr-only">Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            </button>
            <div class="navbar-brand">
            <router-link to="/" class="brand">
              <img src="/images/andalepide.svg" alt="Andalepide">
            </router-link>
           </div>
          </div>
          <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">PEDIDOS Y ENTREGAS <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/gestorentregas"><a>Gestor de Entregas</a></router-link>
              <router-link tag="li" active-class="active" to="/historicoentregas"><a>Historial Empresa</a></router-link>
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">RESTAURANTE <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/platos"><a>Platos</a></router-link>
              <router-link tag="li" active-class="active" to="/asignarmenu"><a>Menus</a></router-link>
              <!--
              <li><a href="combos.html">Combos</a></li>
              <li><a href="delivery.html">Delivery</a></li>
              -->
              </ul>
            </li>
            <li class="dropdown">
              <a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">LIQUIDACIONES <span class="fa fa-angle-down"></span></a>
              <ul class="dropdown-menu">
              <router-link tag="li" active-class="active" to="/restaurante/liquidaciones"><a>Liquidaciones</a></router-link>
              <!--
              <li><a href="andalepide.html">Andalepide</a></li>
              -->
              </ul>
            </li>
            <router-link tag="li" active-class="active" to="/perfil"><a>{{user.proveedorAsociado.razonSocial}}</a></router-link>
            <router-link tag="li" active-class="active" to="/logout"><a><i class="fa fa-sign-out"></i></a></router-link>
            </ul>
          </div>
          </div>
        </nav>
      </header>
      <header class="static"  v-if="user.roles[0] === 'root'">
        <nav class="navbar">
          <div class="container-fluid">
          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar-collapse" aria-expanded="false">
            <span class="sr-only">Menu</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            </button>
            <div class="navbar-brand">
            <router-link to="/" class="brand">
              <img src="/images/andalepide.svg" alt="Andalepide">
            </router-link>
           </div>
          </div>
          <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="nav navbar-nav pull-right">
              <router-link tag="li" active-class="active" to="/stats"><a>Estadísticas</a></router-link>
              <router-link tag="li" active-class="active" to="/campaigns"><a>Campañas</a></router-link>
              <router-link tag="li" active-class="active" to="/adminroot"><a>Admin</a></router-link>
              <li class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">LIQUIDACIONES <span class="fa fa-angle-down"></span></a>
                <ul class="dropdown-menu">
                  <router-link tag="li" active-class="active" to="/liquidaciones/clientes"><a>Clientes</a></router-link>
                  <router-link tag="li" active-class="active" to="/liquidaciones/proveedores"><a>Proveedores</a></router-link>
                </ul>
              </li>
              <router-link tag="li" active-class="active" to="/admingestorentregas"><a>Pedidos</a></router-link>
              <router-link tag="li" active-class="active" to="/categorias"><a>Categorias</a></router-link>
              <li class="dropdown">
                <a class="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">Parámetros <span class="fa fa-angle-down"></span></a>
                <ul class="dropdown-menu">
                  <router-link tag="li" active-class="active" data-toggle="tooltip" rel="tooltip" data-placement="bottom" data-original-title="Unidades de Medida" title="Unidades de Medida" to="/measureUnits"><a>Unidades</a></router-link>
                  <router-link tag="li" active-class="active" data-toggle="tooltip" rel="tooltip" data-placement="bottom" data-original-title="Notificaciones Automáticas" title="Notificaciones Automáticas" to="/notifications"><a><i class="fa fa-whatsapp"></i> Notificaciones Automáticas</a></router-link>
                </ul>
              </li>
              <router-link tag="li" active-class="active" to="/combos"><a>Combos</a></router-link>
              <router-link tag="li" active-class="active" to="/proveedores"><a>Proveedores</a></router-link>
              <router-link tag="li" active-class="active" to="/clientes"><a>Clientes</a></router-link>
              <router-link tag="li" active-class="active" to="/perfil"><a>{{user.displayName}}</a></router-link>
              <router-link tag="li" active-class="active" to="/repararpedidos"><a>Reparar pedidos</a></router-link>
              <router-link tag="li" active-class="active" to="/logout"><a><i class="fa fa-sign-out"></i></a></router-link>
            </ul>
          </div>
          </div>
        </nav>
      </header>
    </div>
    </template>
    
  </div>
</template>

<script>
import $ from 'jquery'
import 'animate.css'
export default {
  props: ['user', 'carrito'],
  computed: {
    totalCarrito () {
      let suma = 0
      this.carrito.forEach((itemCarrito) => {
        itemCarrito.proveedor.forEach((proveedor) => {
          return proveedor.platos.map((plato) => {
            suma += plato.cantidad
          })
        })
      })
      return suma
    }
  },
  mounted () {
    $.fn.extend({
      animateCss: function (animationName) {
        var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend'
        this.addClass('animated ' + animationName).one(animationEnd, function () {
          $(this).removeClass('animated ' + animationName)
        })
      }
    })
  },
  methods: {
    activarModal () {
      console.log('partners')
      this.$emit('activar-modal')
    },
    irACheckOut () {
      const me = this
      const rol = me.user.roles[0]
      if (rol === 'user') {
        me.$router.push({
          path: '/checkout'
        })
      }
      if (rol === 'admincliente') {
        me.$router.push({
          path: '/checkoutadmin'
        })
      }
    },
    toggleCarrito () {
      this.$emit('toggle-carrito')
    },
    logout () {
      console.log('logout nav')
      this.$emit('send-logout')
    }
  },
  watch: {
    totalCarrito (newVal) {
      $('.total').animateCss('shake')
    }
  }
}
</script>



// WEBPACK FOOTER //
// NavIndex.vue?4b41472d